import { combineReducers } from 'redux';
import checklogin from './checklogin';
import token from './token';
import addtocart from './addtocart';


const todoApp = combineReducers({
    checklogin,
    token,
    addtocart
});

export default todoApp;